import { isPositivePurchasePrice } from '../../../../utils/inventoryInputs';
export const EXPECTED_ITEM_STATUS_SELECT_ORDER = [
  'pending',
  'scanned_partial',
  'scanned_full',
  'scanned_over'
];

export const EXPECTED_ITEM_STATUS_LABELS = {
  pending: 'Очікується',
  scanned_partial: 'Проскановано частково',
  scanned_full: 'Проскановано',
  scanned_over: 'Перескан',
  posted: 'Викладено на сайт'
};

export function expectedItemStatusLabel(status) {
  if (!status) return '—';
  return EXPECTED_ITEM_STATUS_LABELS[status] || status;
}

export function expectedItemStatusBadgeClass(status) {
  if (!status) return 'badge badge-light text-muted';
  if (status === 'scanned_full') return 'badge badge-success';
  if (status === 'scanned_partial') return 'badge badge-warning';
  if (status === 'scanned_over') return 'badge badge-danger';
  if (status === 'posted') return 'badge badge-dark';
  return 'badge badge-secondary';
}

/** Позитивна ціна закупки — потрібна для внесення на склад */
export function expectedItemHasValidPurchasePrice(it) {
  return isPositivePurchasePrice(it?.purchasePrice);
}
